module.exports = __webpack_public_path__ + "img/horizontal_5_1_8023.57b03b02.png";